import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Snackbar from '@material-ui/core/Snackbar';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom'
import { green } from '@material-ui/core/colors';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { GetPurchase, EditPurchase } from '../../fetchs';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';

//import './product.styles.css';

const useStyles = theme => ({
  appBar: {
    position: 'relative',
  },
  layout: {
    width: 'auto',
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    [theme.breakpoints.up(600 + theme.spacing(2) * 2)]: {
      width: 1200,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  paper: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    padding: theme.spacing(2),
    [theme.breakpoints.up(600 + theme.spacing(3) * 2)]: {
      marginTop: theme.spacing(6),
      marginBottom: theme.spacing(6),
      padding: theme.spacing(3),
    },
  },
  stepper: {
    padding: theme.spacing(3, 0, 5),
  },
  buttons: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  button: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(1),
  },
  container: {
    // width: 600,
    display: 'flex',
    flexWrap: 'wrap',
  },
  buttonProgress: {
    color: green[500],
    position: 'relative',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12
  },
});

class Purchase extends Component {
  constructor(props) {
    super(props);

    this.state = {
      userId: '',
      factorId: '',
      isOfficial: false,
      description: '',
      priceSum: '',
      customer: undefined,
      purchasedProducts: [],
      allProducts: [],
      loading: false,
      productLoading: false,
      saving: false,
      openSnackbar: false,
      errorMessage: ''
    }
  }

  componentDidMount() {
    const purchaseId = this.props.match.params.purchaseId;
    if (purchaseId) {
      this.loadPurchase(purchaseId);
    }
  }

  loadPurchase = (purchaseId) => {
    this.setState({ loading: true, purchaseId: purchaseId });
    GetPurchase(purchaseId)
      .then(response => {
        this.setState({ loading: false });
        return response.json();
      })
      .then(responseJson => {
        if (responseJson.Message)
          this.setState({ errorMessage: responseJson.Message, openSnackbar: true });
        else
          this.setState({
            factorId: responseJson.factorId,
            isOfficial: responseJson.isOfficial,
            description: responseJson.description,
            customer: responseJson.customer,
            userId: responseJson.userId,
            priceSum: responseJson.priceSum,
            purchasedProducts: responseJson.purchasedProducts
          });
      })
      .catch(error => {
        this.setState({ loading: false });
        console.log(error);
      });
  }

  handleSave = () => {
    EditPurchase(this.state.purchaseId, {
      factorId: this.state.factorId,
      isOfficial: this.state.isOfficial,
      description: this.state.description,
      purchasedProducts: this.state.purchasedProducts,
      userId: this.state.userId
    }).then(response => {
      if (response.status === 400) {
        console.log(response);
      } else if (response.status === 200) {
        this.props.history.push('/main/Purchases');
      }
      return response.json();
    }).then(responseJson => {
      if (responseJson.Message)
          this.setState({ errorMessage: responseJson.Message, openSnackbar: true });
    }).catch(error => {
      console.error(error);
    });
  };

  handleChange = name => event => {
    this.setState({ [name]: event.target.value });
  }

  handleCountChange = productId => event => {
    let purchasedProducts = [...this.state.purchasedProducts];
    for (let i = 0; i < purchasedProducts.length; i++) {
      if (purchasedProducts[i].productId === productId)
        purchasedProducts[i].count = event.target.value;
    }
    this.setState({ purchasedProducts: purchasedProducts });
  }

  handleVisitorOffChange = productId => event => {
    let purchasedProducts = [...this.state.purchasedProducts];
    for (let i = 0; i < purchasedProducts.length; i++) {
      if (purchasedProducts[i].productId === productId)
        purchasedProducts[i].visitorOff = event.target.value;
    }
    this.setState({ purchasedProducts: purchasedProducts });
  }

  handleRemoveItem = index => event => {
    this.setState(state => {
      const purchasedProducts = state.purchasedProducts.filter((item, j) => index !== j);
      return {
        purchasedProducts
      };
    });
  }

  handleCloseSnackbar = () => {
    this.setState({ openSnackbar: false })
  }

  calculateSumPrice = () => {
    let purchasedProducts = [...this.state.purchasedProducts];
    let sum = 0;
    for (let i = 0; i < purchasedProducts.length; i++) {
      sum += purchasedProducts[i].sumPrice;
    }
    return sum;
  }

  render() {
    const { classes } = this.props;
    return (
      <React.Fragment>
        <CssBaseline />
        <main className={classes.layout}>
          <Paper className={classes.paper}>
            <Typography component="h1" variant="h4" align="center">
              ویرایش فاکتور
            </Typography>
            <Grid container>
              <Grid item md={5}>
                <React.Fragment>
                  <form className={classes.container} noValidate autoComplete="off">
                    <Grid container spacing={3}>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          id="standard-name"
                          label="نام خریدار"
                          disabled
                          fullWidth
                          className={classes.textField}
                          value={this.state.customer ? this.state.customer.firstName + " " + this.state.customer.lastName : ''}
                          margin="normal"
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          id="standard-price"
                          label="شماره فاکتور"
                          required
                          fullWidth
                          className={classes.textField}
                          value={this.state.factorId}
                          onChange={this.handleChange('factorId')}
                          margin="normal"
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <TextField
                          id="standard-wholesale"
                          label="توضیحات"
                          fullWidth
                          className={classes.textField}
                          value={this.state.description}
                          onChange={this.handleChange('description')}
                          margin="normal"
                        />
                      </Grid>
                      {/* <Grid item xs={12} sm={6}>
                      <TextField
                        id="standard-select-category"
                        select
                        label="دسته بندی"
                        required
                        fullWidth
                        className={classes.textField}
                        value={this.state.categoryId}
                        onChange={this.handleChange('categoryId')}
                        SelectProps={{
                          MenuProps: {
                            className: classes.menu,
                          },
                        }}
                        margin="normal"
                        >
                        {this.state.categories.map(option => (
                          <MenuItem key={option.categoryId} value={option.categoryId}>
                            {option.name}
                          </MenuItem>
                        ))}
                      </TextField>
                    </Grid> */}
                      {/* <FormControlLabel
                      control={
                        <Checkbox
                          checked={this.state.isAvailable}
                          onChange={this.handleCheckChange('isAvailable')}
                          value="isAvailable"
                          color="primary"
                        />
                      }
                      label="در دسترس؟"
                    /> */}
                      <Grid item xs={12}>
                        <Button
                          variant="contained"
                          color="primary"
                          fullWidth
                          disabled={this.state.loading}
                          onClick={this.handleSave}>ذخیره</Button>
                      </Grid>
                    </Grid>
                  </form>
                </React.Fragment>
              </Grid>
              <Grid item md={7}>
                <Table className="table"
                  aria-labelledby="tableTitle"
                  size={'medium'}>
                  <TableHead>
                    <TableRow>
                      <TableCell>نام</TableCell>
                      <TableCell>تعداد</TableCell>
                      <TableCell>تخفیف ویزیتور</TableCell>
                      <TableCell>قیمت واحد</TableCell>
                      <TableCell>تخفیف واحد</TableCell>
                      <TableCell>قیمت کل</TableCell>
                      <TableCell>حذف</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {this.state.purchasedProducts.length ? this.state.purchasedProducts.map((product, index) => {
                      return <TableRow hover
                        tabIndex={-1}>
                        <TableCell>{product.product.name}</TableCell>
                        <TableCell>
                          <TextField
                            id="standard-count"
                            fullWidth
                            className={classes.textField}
                            value={product.count}
                            onChange={this.handleCountChange(product.productId)}
                            margin="normal"
                          />
                        </TableCell>
                        <TableCell>
                          <TextField
                            id="standard-visitor-off"
                            fullWidth
                            className={classes.textField}
                            value={product.visitorOff}
                            onChange={this.handleVisitorOffChange(product.productId)}
                            margin="normal"
                          />
                        </TableCell>
                        <TableCell>{product.price}</TableCell>
                        <TableCell>{product.off}</TableCell>
                        <TableCell>{product.sumPrice}</TableCell>
                        <TableCell><HighlightOffIcon onClick={this.handleRemoveItem(index)} /></TableCell>
                      </TableRow>
                    }) : ""}
                    <TableRow>
                      <TableCell colSpan={5}>جمع کل</TableCell>
                      <TableCell colSpan={2}>{this.calculateSumPrice()}</TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
                {/* <ProductList /> */}
                {/* <div>
                    <input
                      accept="image/*"
                      className={classes.input}
                      style={{ display: 'none' }}
                      id="raised-button-file"
                      multiple
                      type="file"
                      onChange={this.handleSelectFile}
                    />
                    <label htmlFor="raised-button-file">
                      <Button 
                        fullWidth 
                        variant="contained" 
                        component="span" 
                        className={classes.button}
                      >
                        ارسال عکس جدید برای محصول
                      </Button>
                      {this.state.uploadPic && <CircularProgress size={24} className={classes.buttonProgress} />}
                    </label>
                  </div>
                  <div>
                    {this.state.pics.map((pic, index) => {
                      return (
                        <div className="picParent">
                          <img src={`http://backend.sohresalamat.ir/${pic.picUrl}`} className="picture" alt={pic.description} />
                          <CancelIcon className="closeIcon" onClick={() => this.handleRemovePic(index)} />
                        </div>
                      )
                    })} 
                  </div> */}
              </Grid>
            </Grid>
          </Paper>
          <Snackbar
            anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
            autoHideDuration={3000}
            open={this.state.openSnackbar}
            ContentProps={{
              'aria-describedby': 'message-id',
              'class': 'error MuiTypography-root MuiPaper-root MuiPaper-elevation6 MuiSnackbarContent-root MuiTypography-body2'
            }}
            message={<span id="message-id"> {this.state.errorMessage} </span>}
            onClose={() => this.handleCloseSnackbar(false)} />
        </main>
      </React.Fragment>
    )
  };
}

Purchase.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withRouter(withStyles(useStyles)(Purchase));
